
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import Post from "@/models/post";
import Link from "@/components/Link.vue";
import BackButton from "@/components/BackButton.vue";

const namespace = "PostModule";

@Component({
  components: {
    Link,
    BackButton
  }
})

export default class Home extends Vue{
  @Action('fetchData', { namespace }) private fetchData!: () => any;
  @Mutation('setPostId', {namespace}) private setPostId!: (value:string) => any;
  @State('posts', { namespace }) private posts!: () => Post[];
  @State('post', { namespace }) private post!: () => Post[];
  @State('loading', { namespace }) private loading!: () => boolean;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }
  
  private async created(){
    this.setPostId(this.$route.params.id);
    await this.fetchData();
  }
};
